import clsx from 'clsx';
import { ReactNode, ElementType } from 'react';

type TContainerProps = {
  className?: string;
  id?: string;
  as?: ElementType;
  children?: ReactNode;
};
export const Container = (props: TContainerProps) => {
  const Wrapper = props.as || 'div';
  return (
    <Wrapper className={clsx('w-full sm:px-[32px] xl:px-[160px]', props.className)} id={props.id}>
      {props.children}
    </Wrapper>
  );
};
